import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'state/store';

import {
  useRefreshSpecialValidationNotifications,
  useValidateSpecials,
} from './useValidateSpecials';

/**
 * Validates selected specials before entering Payment.
 *
 * Validation failures are reported to the applicant through notifications, but
 * never prevent payment navigation. Transport failures are logged by
 * useValidateSpecials and likewise do not block the applicant.
 */
export function useValidateSpecialsBeforePayment(): () => Promise<void> {
  const { isLeadProfile = false } = useSelector((state: RootState) => state.auth);
  const validateSpecials = useValidateSpecials();
  const refreshNotifications = useRefreshSpecialValidationNotifications();

  return useCallback(async (): Promise<void> => {
    if (isLeadProfile) return;

    try {
      const areSpecialsValid = await validateSpecials();
      if (!areSpecialsValid) refreshNotifications();
    } catch {
      // Validation transport failures are logged by useValidateSpecials and must not block payment.
    }
  }, [isLeadProfile, refreshNotifications, validateSpecials]);
}
